module.exports = __webpack_public_path__ + "quanthum.215687807719f48160e0.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/assets/vcg/css/fonts/quanthum/quanthum.woff?8kbwol
// module id = ../../../../../src/assets/vcg/css/fonts/quanthum/quanthum.woff?8kbwol
// module chunks = styles